import { render, staticRenderFns } from "./PartnerDeclineContract.vue?vue&type=template&id=3166c6fd&scoped=true&"
import script from "./PartnerDeclineContract.vue?vue&type=script&lang=js&"
export * from "./PartnerDeclineContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3166c6fd",
  null
  
)

export default component.exports